<!-- ProductPlaylistManager.vue – Manage playlists attached to a product -->
<template>
  <div class="product-playlist-manager">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div>
        <h4 class="mb-0">
          <feather-icon icon="ApertureIcon" size="20"></feather-icon>
          پلی‌لیست‌های محصول
        </h4>
      </div>
      <b-button variant="primary" @click="openAttachPlaylistModal">
        <feather-icon icon="PlusIcon"></feather-icon>
        پیوست پلی‌لیست
      </b-button>
    </div>
    <!-- Playlist Grid -->
    <div v-if="playlists.length === 0" class="text-center py-4">
      <feather-icon icon="ListIcon" size="40"></feather-icon>
      <p class="mt-2">هیچ پلی‌لیستی به این محصول پیوست نشده است.</p>
    </div>

    <b-row v-else>
      <b-col
          v-for="playlist in playlists"
          :key="playlist.id"
          cols="12"
          sm="6"
          md="4"
          lg="3"
          class=""
      >
        <b-card class="playlist-card">
          <b-card-body>
            <div class="d-flex justify-content-between align-items-start">
              <div>
                <h6 class="mb-0 font-weight-bold">{{ playlist.title }}</h6>
                <div class="playlist-meta text-muted small">
                  <span>{{ playlist.items ? playlist.items.length : 0 }} ویدیو</span>
                  <span class="mx-1">·</span>
                  <span>{{ playlist.isActive ? 'فعال' : 'غیرفعال' }}</span>
                </div>
              </div>
              <b-button
                  size="sm"
                  variant="outline-danger"
                  @click="confirmDetachPlaylist(playlist)"
              >
                <feather-icon icon="XIcon" size="14"></feather-icon>
              </b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- Attach Playlist Modal -->
    <PlaylistPickerModal
        ref="attachPlaylistModal"
        :product-id="productId"
        @attached="onPlaylistAttached"
    />
  </div>
</template>

<script>
import {BButton, BCard, BCardBody, BCol, BRow} from 'bootstrap-vue'
import {ProductMediaPlaylistsDetachRequest, ProductMediaPlaylistsRequest} from '@/libs/Api/ProductMedia'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import PlaylistPickerModal from './PlaylistPickerModal.vue'

export default {
  name: 'ProductPlaylistManager',
  components: {
    BButton,
    BCard,
    BCardBody,
    BCol,
    BRow,
    PlaylistPickerModal,
  },
  props: {
    productId: {
      type: Number | String,
      required: true
    }
  },
  data: function () {
    return {
      loading: false,
      playlists: [],
    }
  },
  created: function () {
    this.fetchPlaylists()
  },
  methods: {
    showToast: function (variant, title, text) {
      this.$toast({
        component: ToastificationContent,
        position: 'bottom-center',
        props: {
          title: title,
          icon: variant === 'success' ? 'CheckIcon' : 'XIcon',
          variant: variant,
          text: text
        }
      })
    },

    // ===== Fetch Playlists =====
    fetchPlaylists: function () {
      var self = this
      self.loading = true
      var request = new ProductMediaPlaylistsRequest(this)
      request.setParams(this.productId)
      request.fetch(
          function (content) {
            self.playlists = content || []
            self.loading = false
          },
          function (error) {
            self.loading = false
          }
      )
    },

    // ===== Attach Playlist =====
    openAttachPlaylistModal: function () {
      this.$refs.attachPlaylistModal.show()
    },
    onPlaylistAttached: function () {
      this.fetchPlaylists()
      this.showToast('success', 'موفق', 'پلی‌لیست با موفقیت به محصول پیوست شد.')
    },

    // ===== Detach Playlist =====
    confirmDetachPlaylist: function (playlist) {
      var self = this
      this.$bvModal.msgBoxConfirm(
          'آیا از جدا کردن پلی‌لیست "' + playlist.title + '" از محصول اطمینان دارید؟',
          {
            title: 'تأیید جدا کردن',
            okVariant: 'danger',
            okTitle: 'جدا کردن',
            cancelTitle: 'لغو',
            headerBgVariant: 'transparent',
            headerTextVariant: 'light'
          }
      ).then(function (confirmed) {
        if (confirmed) {
          self.detachPlaylist(playlist.id)
        }
      })
    },
    detachPlaylist: function (playlistId) {
      var self = this
      self.loading = true
      var request = new ProductMediaPlaylistsDetachRequest(this)
      request.setParams({playlistId: playlistId})
      request.fetch(
          function () {
            self.loading = false
            self.fetchPlaylists()
          },
          function (error) {
            self.loading = false
          }
      )
    }
  }
}
</script>

<style scoped>
.playlist-card {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.playlist-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.playlist-meta {
  font-size: 12px;
  color: #94a3b8;
}
</style>
